/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Ajuste visual de totales en venta súper
 *      3       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Distribución responsiva de venta súper
 *      4       | 11/06/2026 | Lic. José Luis Aragón Cervantes  | Clave de cliente en cabecero y atajo Alt+D a devoluciones
 *      5       | 16/08/2026 | Lic. José Luis Aragón Cervantes  | Integra préstamos a empleados desde Venta Super con validación de supervisor
 *      6       | 30/08/2026 | Lic. José Luis Aragón Cervantes  | Alt+F12 elimina venta con confirmación; reimpresión pasa a Alt+P
 *      7       | 19/10/2026 | Lic. José Luis Aragón Cervantes  | Ctrl+Alt+F8 ejecuta apertura manual de cajón de dinero
 * ---------------------------------------------------------------------------------------
*/
import { Fragment, useEffect, useState, useRef, Alert } from 'react'
import { IconButton, Tooltip, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSesion } from "../../context/System/SesionContext"
import { useVentas } from "../../context/Ventas/VentasContext";
import { useRequest } from "../../context/System/RequestContext";
import { apiStatusCaja } from "../../settings/ApiConfig";
import { useListenVentasReset } from "../../hooks/useBrowserTabsSync";
import { useFormTabLock } from "../../hooks/useFormTabLock";
import EditIcon from "@mui/icons-material/Edit";
import SizeSoftXImageAnimation from '../leyout/SizeSoftXImageAnimation'
import SizeSoftXTableVentas from '../leyout/SizeSoftXTableVentas';
import SizeSoftXDetallesVentas from "../leyout/SizeSoftXDetallesVentas"
import SizeSoftXVentasLayout from '../leyout/SizeSoftXVentasLayout';
import SizeSoftXAlert from "../utils/SizeSoftXAlert"
import SizeSoftXLectorCodigoBarras from "../leyout/SizeSoftXLectorCodigoBarras"
import SizeSoftXModal from "../leyout/SizeSoftXModal"
import MnuVentasActions from "./MnuVentasActions"
import FrmVentasDetalles from "../../components/ventas/FrmVentasDetalles"
import ModalEditarPartidasVentas from "./ModalEditarPartidasVentas"
import ModalCobroVentas from "./ModalCobroVentas"
import ModalBuscarArticulosParaVenta from "../herramientas/ModalBuscarArticulosParaVenta"
import ModalJalarPreventasCotizaciones from "./ModalJalarPreventasCotizaciones"
import MnuOtherActions from "./MnuOtherActions"
import ModalGenerarApartados from "./ModalGenerarApartados"
import SizeSoftXLoadingProcess from "../leyout/SizeSoftXLoadingProcess"
import FrmLoginValidate from '../administracion/FrmLoginValidate';
import ModalAperturaCaja from '../administracion/ModalAperturaCaja';
import ModalCierreCaja from '../administracion/ModalCierreCaja';
import ModalRetiroCapital from '../administracion/ModalRetiroCapital';
import ModalAbonoPrestamoVenta from './ModalAbonoPrestamoVenta';
import ModalPrestamoEmpleado from '../administracion/ModalPrestamoEmpleado';
import ModalGenerarValePorCambio from './ModalGenerarValePorCambio';
import ModalAplicacionDescuentos from './ModalAplicacionDescuentos';
import ModalValidarCliente from './ModalValidarCliente';
import ModalReimpresionRemisiones from './ModalReimpresionRemisiones';
import SizeSoftXConfirmDialog from '../leyout/SizeSoftXConfirmDialog';
import ModalBuscarClientes from '../herramientas/ModalBuscarClientes';
import { useLayout } from '../../context/System/LayoutContext';
export default function FrmVentaSuper() {
    const navigate = useNavigate();
    const panelCodigoBarras = useRef(null);
    const lectorRef = useRef(null);
    const ventaSuperLeftRef = useRef(null);
    const listaRemisionTemporalRef = useRef([]);
    const { isLocked: isFormLocked, lockInfo } = useFormTabLock('ventas', {
        title: 'Ventas',
        onLockDetected: (info) => {
            console.warn(`El formulario de ${info?.title || 'Ventas'} ya está abierto en otra pestaña`);
        }
    });
    const { usuarioData, getPermisoBoton, parametrosCajaForm, handleObtenerParametrosCaja } = useSesion();
    const [dataCliente, setDataCliente] = useState({});
    const [clienteParaDescuento, setClienteParaDescuento] = useState(null);
    const { handleOpenAlert } = useLayout();
    const { GetRequest } = useRequest();
    const [barcode, setBarcode] = useState("");
    const [openModalAperturaCaja, setOpenModalAperturaCaja] = useState(false);
    const [openModalCierreCaja, setOpenModalCierreCaja] = useState(false);
    const [openModalReimpresionRemisiones, setOpenModalReimpresionRemisiones] = useState(false);
    const [openConfirmEliminarVenta, setOpenConfirmEliminarVenta] = useState(false);
    const [openModalAbonoPrestamoVenta, setOpenModalAbonoPrestamoVenta] = useState(false);
    const [openModalPrestamoEmpleado, setOpenModalPrestamoEmpleado] = useState(false);
    const [openModalLoginApertura, setOpenModalLoginApertura] = useState(false);
    const [openModalLoginCierre, setOpenModalLoginCierre] = useState(false);
    const [openModalLoginPrestamo, setOpenModalLoginPrestamo] = useState(false);
    const [openModalValePorCambio, setOpenModalValePorCambio] = useState(false);
    const [openModalLoginValePorCambio, setOpenModalLoginValePorCambio] = useState(false);
    const [usuarioAutorizaVale, setUsuarioAutorizaVale] = useState("");
    const [statusCajaActual, setStatusCajaActual] = useState(null);
    const [usuarioAutorizaPrestamo, setUsuarioAutorizaPrestamo] = useState("");
    const {
        listaRemisionTemporal,
        partidaSeleccionada,
        handleChangePartidaSeleccionada,
        handleClickEditarPartida,
        handleCerrarModalEditarPartidas, openModal,
        handleClickRefrescarDatosVenta,
        handleRetotalizarCuentaVenta,
        handleClickEliminarPartidaVentas,
        handleSumarPartidaVentas,
        handleRestarPartidaVentas,
        handleBuscarClienteFromClave,
        handleCerrarModalCobrarVenta,
        openModalPartidas,
        clienteForm,
        openModalCobrarVenta,
        handClickCobrarVenta,
        setVentaTotales, ventaTotales, getVentaTotalesForm,
        statusImpresionDirecta,
        openModalBuscarArticulos,
        handleCloseModalBuscarArticulos,
        statusCloseModal,
        handleRegistrarArticuloSubmitVenta,
        handleCambioTipoVenta,
        handleCerrarModalJalarPreVentaCotizacion,
        handleInyectarPreventaCotizacionAVenta,
        openModalJalarPreventaCotizacion,
        //Modal generar apartado
        handleCerrarModalGenerarApartado,
        handleGenerarApartadoConPagos,
        openModalGenerarApartado,
        //Ticket
        statusAbrirDescuentos, handeCerrarModalDescuentos,
        statusWaiting,
        openModalValidarAcceso,
        handleCloseModalLoginValidarAcceso,
        handleAbrirDescuentosVenta,
        handleClickDescuentoVenta,
        //Validar Cliente
        statusValidarCliente, handleCerrarValidarCliente, handleViewFormDescuentos,
        handleClickRegresarMainDashboard,
        handleAbrirModalJalarPreVentaCotizacion,
        setStatusKeyActions,
        statusKeyActions,
        handleArirModalBuscarArticulos,
        handleArirModalBuscarCliente,
        handleCerrarModalBuscarCliente,
        openModalBuscarCliente,
        handleArirModalCobrarVenta,
        handleAbrirModalGenerarApartado,
        handleClickEliminarVenta,
        moduloActivo, setModuloActivo,
        // Retiro Capital
        openModalRetiroCapital,
        openModalLoginRetiro,
        setOpenModalLoginRetiro,
        handleCerrarRetiroCapital,
        handleRetiroCapitalExitoso,
        handleConfirmLoginRetiro,
        statusCajaRetiro,
        usuarioAutorizadoRetiro,
        setClienteForm,
        handleAbrirCajonDinero,
        handleInicializarVentanaVentas,
    } = useVentas();
    const handleCerrarModalCobranza = () => {
        handleCerrarModalCobrarVenta();
        requestAnimationFrame(() => ensureBarcodeFocus());
    };
    const [talla, setTalla] = useState(0);
    const [modoCargaDataPreventasCotizaciones, setModoCargaDataPreventasCotizaciones] = useState("PREVENTA");
    // Estado local estable para el modal de buscador de artículos
    const [mostrarBuscadorArticulos, setMostrarBuscadorArticulos] = useState(false);
    // Efecto para bloquear acceso si el formulario ya está abierto en otra pestaña
    useEffect(() => {
        if (isFormLocked) {
            handleOpenAlert(
                `El formulario de ${lockInfo?.title || 'Ventas'} ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.`,
                "error"
            );
            setTimeout(() => {
                handleClickRegresarMainDashboard();
            }, 900);
        }
    }, [isFormLocked]);
    const hanldeTallaSelect = (e) => {
        setTalla(e);
    };
    const handleRegistrarArticuloCodigoBarras = async(dataArticulo, almacenExhibidor) => {
        setMostrarBuscadorArticulos(false);
        await handleCambioTipoVenta("VENTA");
        await handleRegistrarArticuloSubmitVenta(dataArticulo.codigobarras, almacenExhibidor);
    };
    const handleJalarPreventaCotizacion = (e) => {
        handleInyectarPreventaCotizacionAVenta(e);
    };
    const ClickEliminarVenta = () => {
        handleClickEliminarVenta();
    };
    const verificarStatusCaja = async () => {
        if (!parametrosCajaForm.caja || parametrosCajaForm.caja === 'CAJA-DEFAULT') {
            handleOpenAlert("Caja no configurada. No se puede cobrar.", "warning");
            return { puedeCobrar: false, statusCaja: null };
        }
        try {
            const url = apiStatusCaja.replace("{caja}", parametrosCajaForm.caja);
            const response = await GetRequest({ url });
            if (response.hasError) {
                handleOpenAlert(response.message, "error");
                return { puedeCobrar: false, statusCaja: null };
            }
            const statusData = response.result;
            setStatusCajaActual(statusData);
            if (!statusData.abierta) {
                return { puedeCobrar: false, statusCaja: statusData, necesitaApertura: true };
            }
            return { puedeCobrar: true, statusCaja: statusData };
        } catch (error) {
            handleOpenAlert("Error al verificar status de caja: " + error.message, "error");
            return { puedeCobrar: false, statusCaja: null };
        }
    };
    const handleVerificarYAbrirCobrarVenta = async () => {
        if (listaRemisionTemporal.length === 0) {
            handleOpenAlert("No hay artículos en la venta para cobrar.");
            return;
        }
        const { puedeCobrar, statusCaja, necesitaApertura } = await verificarStatusCaja();
        if (necesitaApertura) {
            const msg = `La caja ${statusCaja.caja} se encuentra en estatus ${statusCaja.status}. ` +
                        `Última apertura registrada: ${statusCaja.fechaultimaapertura ? new Date(statusCaja.fechaultimaapertura).toLocaleString('es-MX') : 'Sin registro'}. ` +
                        `Detalle: ${statusCaja.mensaje || 'Debe realizar la apertura de caja para continuar.'}`;
            handleOpenAlert(msg, "warning");
            setOpenModalAperturaCaja(true);
            return;
        }
        if (puedeCobrar) {
            handleArirModalCobrarVenta();
        }
    };
    const handleAbrirAperturaCaja = () => {
        if (!parametrosCajaForm.caja || parametrosCajaForm.caja === 'CAJA-DEFAULT') {
            handleOpenAlert("No hay caja seleccionada", "warning");
            return;
        }
        setOpenModalLoginApertura(true);
    };
    const handleConfirmLoginApertura = async (success, usuarioAutorizado) => {
        setOpenModalLoginApertura(false);
        if (!success) return;
        setOpenModalAperturaCaja(true);
    };
    const handleAbrirCierreCaja = () => {
        if (!parametrosCajaForm.caja || parametrosCajaForm.caja === 'CAJA-DEFAULT') {
            handleOpenAlert("No hay caja seleccionada", "warning");
            return;
        }
        setOpenModalLoginCierre(true);
    };
    const handleConfirmLoginCierre = async (success, usuarioAutorizado) => {
        setOpenModalLoginCierre(false);
        if (!success) return;
        setOpenModalCierreCaja(true);
    };
    const handleAbrirPrestamoEmpleado = () => {
        if (!parametrosCajaForm.caja || parametrosCajaForm.caja === 'CAJA-DEFAULT') {
            handleOpenAlert("No hay caja seleccionada", "warning");
            return;
        }
        if (!statusCajaActual?.abierta) {
            handleOpenAlert("No se pueden registrar préstamos mientras la caja esté cerrada", "warning");
            return;
        }
        setOpenModalLoginPrestamo(true);
    };
    const handleConfirmLoginPrestamo = async (success, usuarioAutorizado) => {
        setOpenModalLoginPrestamo(false);
        if (!success) return;
        setUsuarioAutorizaPrestamo(usuarioAutorizado?.usuario || usuarioAutorizado?.Usuario || usuarioData?.Usuario || "");
        setOpenModalPrestamoEmpleado(true);
    };
    const handleAbrirAbonoPrestamoVenta = () => {
        if (!parametrosCajaForm.caja || parametrosCajaForm.caja === 'CAJA-DEFAULT') {
            handleOpenAlert("No hay caja seleccionada", "warning");
            return;
        }
        if (!statusCajaActual?.abierta) {
            handleOpenAlert("No se pueden registrar abonos a préstamos mientras la caja esté cerrada", "warning");
            return;
        }
        setOpenModalAbonoPrestamoVenta(true);
    };
    const handleAbrirValePorCambio = () => {
        if (!parametrosCajaForm.caja || parametrosCajaForm.caja === 'CAJA-DEFAULT') {
            handleOpenAlert("No hay caja seleccionada", "warning");
            return;
        }
        if (!statusCajaActual?.abierta) {
            handleOpenAlert("No se pueden generar vales por cambio mientras la caja esté cerrada", "warning");
            return;
        }
        setOpenModalLoginValePorCambio(true);
    };
    const handleConfirmLoginValePorCambio = async (success, usuarioAutorizado) => {
        setOpenModalLoginValePorCambio(false);
        if (!success) return;
        setUsuarioAutorizaVale(usuarioAutorizado?.usuario || usuarioAutorizado?.Usuario || usuarioData?.Usuario || "");
        setOpenModalValePorCambio(true);
    };
    const handleCierreExitosoCaja = () => {
        setOpenModalCierreCaja(false);
        verificarStatusCaja();
    };
    const handleCierreExitosoApertura = () => {
        setOpenModalAperturaCaja(false);
        verificarStatusCaja().then(({ puedeCobrar }) => {
            if (puedeCobrar) {
                handleArirModalCobrarVenta();
            }
        });
    };
    useEffect(() => {
        handleCambioTipoVenta("VENTA");
        setModuloActivo("VENTA SUPER");
        if (parametrosCajaForm.caja === 'CAJA-DEFAULT' || parametrosCajaForm.caja === null || parametrosCajaForm.caja === undefined) {
            setStatusKeyActions(false);
        }
        handleObtenerParametrosCaja();
        handleCloseModalLoginValidarAcceso();
        handleClickRefrescarDatosVenta();
    }, []);
    useListenVentasReset(() => {
        handleInicializarVentanaVentas();
    });
    useEffect(() => {
        if (parametrosCajaForm.caja === 'CAJA-DEFAULT' || !parametrosCajaForm.caja)
            return;
        handleCloseModalLoginValidarAcceso();
        handleClickRefrescarDatosVenta();
    }, [parametrosCajaForm.folioventa]);
    useEffect(() => {
        if (parametrosCajaForm.caja === 'CAJA-DEFAULT' || !parametrosCajaForm.caja)
            return;
        verificarStatusCaja();
    }, [parametrosCajaForm.caja]);
    useEffect(() => {
        handleRetotalizarCuentaVenta(listaRemisionTemporal);
    }, [listaRemisionTemporal]);
    useEffect(() => {
        if (clienteForm?.razonsocial) {
            window.scrollTo(0, 0);
        }
    }, [clienteForm]);
    useEffect(() => { }, [statusImpresionDirecta]);
    useEffect(() => {
        if (statusCloseModal) {
            panelCodigoBarras.current.focus();
            const inputElement = document.getElementById('txtCodigoBarras');
            if (inputElement) {
                inputElement.focus();
                inputElement.click();
            }
            handleClickRefrescarDatosVenta();
        }
    }, [statusCloseModal]);
    useEffect(() => {
        if (listaRemisionTemporalRef.current.length > 0 && 
            listaRemisionTemporal.length > listaRemisionTemporalRef.current.length && 
            ventaSuperLeftRef.current) {
            ventaSuperLeftRef.current.scrollTop = ventaSuperLeftRef.current.scrollHeight;
        }
        listaRemisionTemporalRef.current = listaRemisionTemporal;
    }, [listaRemisionTemporal]);
    const focusFiltroBuscadorArticulos = () => {
        setTimeout(() => {
            const filtroInput = document.querySelector('input[name="Filtro"]');
            if (filtroInput) {
                filtroInput.focus();
                filtroInput.select();
            }
        }, 150);
    };
    //Key actions windows
    useEffect(() => {
        const handleKeyDown = (event) => {
            // El modal de apartados gestiona sus propios atajos (Alt+Fin, Alt+E/C/D/Q/V/T);
            // no deben dispararse las teclas globales de la venta mientras esté abierto.
            if (openModalGenerarApartado) return;
            if (event.ctrlKey && event.altKey && event.key && event.key.trim().toUpperCase() === "F8") {
                event.preventDefault();
                event.stopPropagation();
                handleAbrirCajonDinero();
                return;
            }
            if (event.altKey && event.key && event.key.trim().toUpperCase() === "F3") {
                event.preventDefault();
                event.stopPropagation();
                handleClickDescuentoVenta();
                return;
            }
            if (event.altKey && (event.code === "KeyO" || event.key?.toUpperCase() === "O")) {
                event.preventDefault();
                event.stopPropagation();
                setModoCargaDataPreventasCotizaciones("PREVENTA");
                setModoCargaDataPreventasCotizaciones("COTIZACION");
                handleAbrirModalJalarPreVentaCotizacion("COTIZACION");
                return;
            }
            if (event.altKey && (event.code === "KeyJ" || event.key?.toUpperCase() === "J")) {
                event.preventDefault();
                event.stopPropagation();
                setModoCargaDataPreventasCotizaciones("COTIZACION");
                setModoCargaDataPreventasCotizaciones("PREVENTA");
                handleAbrirModalJalarPreVentaCotizacion("PREVENTA");
                return;
            }
            if (event.key.trim().toUpperCase() === "F4") {
                event.preventDefault();
                event.stopPropagation();
                handleClickRegresarMainDashboard();
                return;
            }
            if (event.altKey && event.key && event.key.trim().toUpperCase() === "F10") {
                event.preventDefault();
                event.stopPropagation();
                handleVerificarYAbrirCobrarVenta();
                return;
            }
            if (event.altKey && event.key && event.key.trim().toUpperCase() === "F7") {
                event.preventDefault();
                event.stopPropagation();
                handleClickEliminarPartidaVentas(partidaSeleccionada.idpartida);
                return;
            }
            if (event.altKey && event.key && event.key.trim().toUpperCase() === "F12") {
                event.preventDefault();
                event.stopPropagation();
                setOpenConfirmEliminarVenta(true);
                return;
            }
            if (event.ctrlKey && event.altKey && event.key && event.key.trim().toUpperCase() === "A") {
                event.preventDefault();
                event.stopPropagation();
                handleAbrirModalGenerarApartado();
                return;
            }
            if (event.altKey && event.key && event.key.trim().toUpperCase() === "P") {
                event.preventDefault();
                event.stopPropagation();
                setOpenModalReimpresionRemisiones(true);
                return;
            }
            if (event.altKey && event.key && event.key.trim().toUpperCase() === "F2") {
                if (!statusCajaActual?.abierta) {
                    handleOpenAlert("No se pueden realizar operaciones mientras la caja esté cerrada", "warning");
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                handleArirModalBuscarCliente();
                return;
            }
            if (event.altKey && event.key && event.key.trim().toUpperCase() === "F1") {
                // Verificar que la caja esté abierta antes de permitir buscar artículos
                if (!statusCajaActual?.abierta) {
                    handleOpenAlert("No se pueden realizar operaciones mientras la caja esté cerrada", "warning");
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                setMostrarBuscadorArticulos(true);
                handleArirModalBuscarArticulos();
                focusFiltroBuscadorArticulos();
                return;
            }
            if (event.ctrlKey && event.altKey && (event.code === "KeyD" || event.key?.toUpperCase() === "D")) {
                event.preventDefault();
                event.stopPropagation();
                navigate("/devoluciones", { replace: true });
                return;
            }
            else {
                const invalidKeys = ['Insert', 'Home', 'End', 'PageDown', 'PageUp', 'ContextMenu'
                    , 'Meta', 'Shift', 'Control', 'CapsLock', 'F1', 'F2', 'F3'
                    , 'F5', 'F6', 'F9', 'F11'];
                if (invalidKeys.includes(event.key)) { event.preventDefault(); event.stopPropagation(); return; }
            }
        };
        window.addEventListener("keydown", handleKeyDown, true);
        return () => window.removeEventListener("keydown", handleKeyDown, true);
    }, [
        handleClickDescuentoVenta,
        handleAbrirModalJalarPreVentaCotizacion,
        handleClickRegresarMainDashboard,
        handleArirModalBuscarArticulos,
        handleArirModalBuscarCliente,
        handleVerificarYAbrirCobrarVenta,
        ClickEliminarVenta,
        handleAbrirModalGenerarApartado,
        handleAbrirCajonDinero,
        openModalGenerarApartado,
        handleClickEliminarPartidaVentas,
        statusKeyActions,
        mostrarBuscadorArticulos,
        parametrosCajaForm,
        navigate,
    ]);
    const ensureBarcodeFocus = () => {
        if (statusKeyActions) return;
        // si hay un modal abierto, no robes foco
        const modalOpen =
            document.querySelector('[role="dialog"], .MuiModal-root, .MuiDialog-root') !== null;
        if (modalOpen) return;
        lectorRef.current?.focus?.();
    };
    const handleClienteLocalizado = async (cliente) => {
        setClienteParaDescuento(cliente);
        setClienteForm(cliente);
        await handleViewFormDescuentos(true, cliente);
    };
    useEffect(() => {
        if (!statusKeyActions) {
            // reintentos cortos por si MUI está soltando el foco
            let tries = 0;
            const t = setInterval(() => {
                tries++;
                ensureBarcodeFocus();
                if (tries >= 10) clearInterval(t);
            }, 120);
            return () => clearInterval(t);
        }
    }, [statusKeyActions]);
    return (
        <>
            <Fragment>
                <SizeSoftXVentasLayout
                    titlePage="Módulo de venta súper"
                    buttonActions={<MnuVentasActions disabled={!statusCajaActual?.abierta} onOpenBuscador={() => setMostrarBuscadorArticulos(true)} onOpenReimpresion={() => setOpenModalReimpresionRemisiones(true)} onOpenValePorCambio={handleAbrirValePorCambio} />}
                    detailComponent={<FrmVentasDetalles />}
                >
                    <div className="title-page venta-header-card" style={{ display: 'flex', flexWrap: 'wrap', border: '1px solid #ccc', borderRadius: '4px', padding: '12px', backgroundColor: '#fafafa', gap: '16px' }}>
                        <div style={{ minWidth: '150px' }}>
                            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>CAJA</div>
                            <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{parametrosCajaForm.caja}</div>
                            {statusCajaActual && (
                                <Chip
                                    label={statusCajaActual.status}
                                    color={statusCajaActual.abierta ? "success" : "error"}
                                    size="small"
                                    sx={{ mt: 0.5, fontSize: '10px', height: '20px' }}
                                />
                            )}
                        </div>
                        <div style={{ minWidth: '55px' }}>
                            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>TICKET</div>
                            <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{parametrosCajaForm.folioventa}</div>
                        </div>
                        <div style={{ minWidth: '90px' }}>
                            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>ATENDE</div>
                            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{usuarioData.Usuario}</div>
                            <div style={{ fontSize: '11px', color: '#888' }}>{usuarioData.Nombre}</div>
                        </div>
                        <div style={{ minWidth: '150px' }}>
                            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>CLIENTE</div>
                            <div style={{ fontSize: '14px', fontWeight: 'bold', color: clienteForm.razonsocial ? '#1976d2' : '#999' }}>
                                {clienteForm.clavecliente ? `${clienteForm.clavecliente} - ` : ''}{clienteForm.razonsocial || "Sin cliente"}
                            </div>
                        </div>
                        <div style={{ minWidth: '70px' }}>
                            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>DESCUENTO</div>
                            <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#2e7d32' }}>{clienteForm.porcentajedescuento || 0}%</div>
                        </div>
                        <div style={{ minWidth: '150px' }}>
                            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>CONTACTOS</div>
                            <div style={{ fontSize: '12px' }}>{clienteForm.contacto || "-"}</div>
                        </div>
                    </div>
                    <div className="venta-super-container">
                        <div className="venta-super-left" ref={ventaSuperLeftRef}>
                            <SizeSoftXTableVentas
                                columns={[
                                    {
                                        hideSort: false,
                                        field: "editrow",
                                        render: (row) => (
                                            <div>
                                                <IconButton onClick={handleClickEditarPartida}>
                                                    <EditIcon color="primary" />
                                                </IconButton>
                                            </div>)
                                    , width: 30},
                                    { title: "Origen", field: "almacenexhibidor", width: 120 },
                                    { title: "Preventa", field: "nombrevendedor", width: 100 },
                                    { title: "Partida", field: "idpartida" },
                                    { title: "Descripción", field: "descripcion" },
                                    { title: "Medida", field: "medida" },
                                    { title: "Cantidad", field: "cantidad" },
                                    { title: "Costo cliente", field: "costocliente" },
                                    { title: "%", field: "porcentajedescuento" },
                                    { title: "descuento", field: "descuento" },
                                    { title: "Subtotal", field: "subtotal" },
                                    { title: "IVA", field: "iva" },
                                    { title: "Total", field: "total" },
                                    { title: "Costo Unit.", field: "costounitario" },
                                    { title: "Clave artículo", field: "clavearticulo" },
                                    { title: "Folio preventa", field: "foliopreventa" },
                                ]}
                                data={listaRemisionTemporal == null ? [] : listaRemisionTemporal}
                                id="idpartida"
                                row={partidaSeleccionada}
                                setRow={handleChangePartidaSeleccionada}
                                fnDoubleClick={handleClickEditarPartida}
                                fontSize="small"
                                rowsPerPageIntro={50}
                            />
                        </div>
                        <div className="venta-frame-right">
                            <div className="venta-super-right-wrapper">
                                <div className="venta-super-lector-especifico">
                                    <SizeSoftXLectorCodigoBarras
                                        ref={lectorRef}
                                        TipoVenta={"VENTA"}
                                        handleSetCliente={handleBuscarClienteFromClave}
                                        disabled={!statusCajaActual?.abierta}
                                    />
                                </div>
                            </div>
                            <div className="venta-super-right-wrapper">
                                <div className="venta-super-detalles-especifico" ref={panelCodigoBarras}>
                                    <SizeSoftXDetallesVentas
                                        ventasTotales={ventaTotales}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalBuscarArticulosParaVenta
                        openModal={mostrarBuscadorArticulos}
                        handleCloseModal={() => {
                            setMostrarBuscadorArticulos(false);
                            handleCloseModalBuscarArticulos();
                        }}
                        dominio={parametrosCajaForm.dominio}
                        consultarTodosAlmacenes={true}
                        onTallaSelect={hanldeTallaSelect}
                        articuloSelect={(dataFull, almacenSeleccionado) => {
                            handleRegistrarArticuloCodigoBarras(dataFull, almacenSeleccionado);
                        }}
                    />
                    <ModalEditarPartidasVentas
                        openModal={openModalPartidas}
                        rowSelect={partidaSeleccionada}
                        handleClose={handleCerrarModalEditarPartidas}
                        handleEliminar={
                            () => {
                                handleClickEliminarPartidaVentas(partidaSeleccionada.idpartida);
                                handleCerrarModalEditarPartidas();
                            }
                        }
                        handleSubmitEditarPartidaVentaSumar={handleSumarPartidaVentas}
                        handleSubmitEditarPartidaVentaRestar={handleRestarPartidaVentas}
                    />
                    <ModalCobroVentas
                        openModalCobrarVentas={openModalCobrarVenta}
                        montosVenta={ventaTotales}
                        setMontosVenta={setVentaTotales}
                        handleCloseModalCobroVentas={handleCerrarModalCobranza}
                        handleCobrar={handClickCobrarVenta}
                        tieneCliente={Boolean(clienteForm?.clavecliente)}
                    />
                    <ModalJalarPreventasCotizaciones
                        openModalJalarPreventaCotizacion={openModalJalarPreventaCotizacion}
                        handleCloseModalJalarPreventaCotizacion={handleCerrarModalJalarPreVentaCotizacion}
                        handleJalarPreventaCotizacion={handleJalarPreventaCotizacion}
                        modal={modoCargaDataPreventasCotizaciones}
                    />
                    <ModalGenerarApartados
                        openModalJalarPreventaCotizacion={openModalGenerarApartado}
                        handleCloseModalGenerarApartados={handleCerrarModalGenerarApartado}
                        handleGenerarApartado={handleGenerarApartadoConPagos}
                        listaVentas={listaRemisionTemporal}
                    />
                    <ModalAplicacionDescuentos
                        openModal={statusAbrirDescuentos}
                        dataCliente={clienteParaDescuento}
                        remisionVenta={parametrosCajaForm.folioventa}
                        caja={parametrosCajaForm.caja.trim()}
                        handleCloseModalCambioCosto={handeCerrarModalDescuentos}
                        data={listaRemisionTemporal == null ? [] : listaRemisionTemporal}
                    />
                    <ModalValidarCliente
                        openModal={statusValidarCliente}
                        handleClose={handleCerrarValidarCliente}
                        handleClienteEncontrado={handleClienteLocalizado}
                    />
                    <FrmLoginValidate
                        openModal={openModalValidarAcceso}
                        tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR", "DESCUENTOS"]}
                        handleComandoEjecucion={handleAbrirDescuentosVenta}
                        hancleCloseModalValidator={() => handleCloseModalLoginValidarAcceso()}
                    />
                    <ModalAperturaCaja
                        openModal={openModalAperturaCaja}
                        onClose={() => setOpenModalAperturaCaja(false)}
                        onSuccess={handleCierreExitosoApertura}
                        caja={parametrosCajaForm.caja}
                    />
                    <ModalCierreCaja
                        openModal={openModalCierreCaja}
                        onClose={() => setOpenModalCierreCaja(false)}
                        onSuccess={handleCierreExitosoCaja}
                        caja={parametrosCajaForm.caja}
                        statusCaja={statusCajaActual}
                        usuario={usuarioData?.Usuario}
                    />
                    <ModalRetiroCapital
                        openModal={openModalRetiroCapital}
                        onClose={handleCerrarRetiroCapital}
                        onSuccess={handleRetiroCapitalExitoso}
                        caja={parametrosCajaForm.caja}
                        usuarioAutorizado={usuarioAutorizadoRetiro}
                    />
                    <ModalReimpresionRemisiones
                        openModal={openModalReimpresionRemisiones}
                        onClose={() => setOpenModalReimpresionRemisiones(false)}
                        caja={parametrosCajaForm.caja}
                    />
                    <SizeSoftXConfirmDialog
                        open={openConfirmEliminarVenta}
                        title="Eliminar venta"
                        message="¿Desea eliminar toda la venta actual?"
                        handleConfirmDialog={(confirm) => {
                            setOpenConfirmEliminarVenta(false);
                            if (confirm) ClickEliminarVenta();
                        }}
                    />
                    <ModalBuscarClientes
                        openModal={openModalBuscarCliente}
                        handleCloseModal={handleCerrarModalBuscarCliente}
                        onClienteSelect={async (cliente) => {
                            setClienteParaDescuento(cliente);
                            await handleBuscarClienteFromClave(cliente.clavecliente);
                            handleCerrarModalBuscarCliente();
                        }}
                    />
                    <FrmLoginValidate
                        openModal={openModalLoginApertura}
                        tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
                        handleComandoEjecucion={handleConfirmLoginApertura}
                        hancleCloseModalValidator={() => setOpenModalLoginApertura(false)}
                    />
                    <FrmLoginValidate
                        openModal={openModalLoginCierre}
                        tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
                        handleComandoEjecucion={handleConfirmLoginCierre}
                        hancleCloseModalValidator={() => setOpenModalLoginCierre(false)}
                    />
                    <FrmLoginValidate
                        openModal={openModalLoginRetiro}
                        tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
                        handleComandoEjecucion={handleConfirmLoginRetiro}
                        hancleCloseModalValidator={() => setOpenModalLoginRetiro(false)}
                    />
                    <ModalAbonoPrestamoVenta
                        open={openModalAbonoPrestamoVenta}
                        onClose={() => setOpenModalAbonoPrestamoVenta(false)}
                        onSaved={() => {
                            setOpenModalAbonoPrestamoVenta(false);
                            verificarStatusCaja();
                        }}
                    />
                    <ModalPrestamoEmpleado
                        open={openModalPrestamoEmpleado}
                        onClose={() => setOpenModalPrestamoEmpleado(false)}
                        onSaved={() => {
                            setOpenModalPrestamoEmpleado(false);
                            verificarStatusCaja();
                        }}
                        usuarioAutoriza={usuarioAutorizaPrestamo}
                        caja={parametrosCajaForm.caja}
                    />
                    <FrmLoginValidate
                        openModal={openModalLoginPrestamo}
                        tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
                        handleComandoEjecucion={handleConfirmLoginPrestamo}
                        hancleCloseModalValidator={() => setOpenModalLoginPrestamo(false)}
                    />
                    <FrmLoginValidate
                        openModal={openModalLoginValePorCambio}
                        tiposUsuario={["SA", "ADMINISTRADOR", "SUPERVISOR"]}
                        handleComandoEjecucion={handleConfirmLoginValePorCambio}
                        hancleCloseModalValidator={() => setOpenModalLoginValePorCambio(false)}
                    />
                    <ModalGenerarValePorCambio
                        open={openModalValePorCambio}
                        onClose={() => setOpenModalValePorCambio(false)}
                        onSaved={() => {
                            setOpenModalValePorCambio(false);
                            verificarStatusCaja();
                        }}
                        caja={parametrosCajaForm.caja}
                        usuarioAutoriza={usuarioAutorizaVale}
                        usuario={usuarioData?.Usuario}
                    />
                    <SizeSoftXModal />
                    <SizeSoftXAlert />
                    <MnuOtherActions
                        statusCajaActual={statusCajaActual}
                        onAbrirAperturaCaja={handleAbrirAperturaCaja}
                        onAbrirCierreCaja={handleAbrirCierreCaja}
                        onAbrirAbonoPrestamoVenta={handleAbrirAbonoPrestamoVenta}
                        onAbrirPrestamoEmpleado={handleAbrirPrestamoEmpleado}
                    />
                    <SizeSoftXLoadingProcess
                        open={statusWaiting} message="Procesando información, por favor espere..."
                    />
                </SizeSoftXVentasLayout>
            </Fragment>
        </>
    )
}
